import { render, staticRenderFns } from "./LoggedUser-comp.vue?vue&type=template&id=7d5ec304&scoped=true&"
import script from "./LoggedUser-comp.vue?vue&type=script&lang=js&"
export * from "./LoggedUser-comp.vue?vue&type=script&lang=js&"
import style0 from "./LoggedUser-comp.vue?vue&type=style&index=0&id=7d5ec304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ec304",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
